import { render, staticRenderFns } from "./CascadingPermissionsProfilesEditForm.vue?vue&type=template&id=38af067e"
import script from "./CascadingPermissionsProfilesEditForm.vue?vue&type=script&lang=js"
export * from "./CascadingPermissionsProfilesEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports